import { request } from "api/actions";
import { AxiosRequestConfig } from "axios";
import types from "./types";

export const locationsFetch = (
    app: string,
    config?: AxiosRequestConfig,
    onResponse?: Function
) =>
    request(
        types.LOCATIONS_FETCH_REQUEST,
        types.LOCATIONS_FETCH_FAILED,
        types.LOCATIONS_FETCH_SUCCESS,
        "eventLocationsFetch",
        {
            config: { ...config, params: { _app: app, ...config?.params } },
        },
        onResponse,
        undefined,
        "event"
    );

export const locationsRoles = (
    locationId: number,
    app: string,
    config?: AxiosRequestConfig,
    onResponse?: Function
) =>
    request(
        types.LOCATIONS_ROLES_REQUEST,
        types.LOCATIONS_ROLES_FAILED,
        types.LOCATIONS_ROLES_SUCCESS,
        "eventLocationsRoles",
        {
            config: { ...config, params: { _app: app, ...config?.params } },
            url: { id: locationId },
        },
        onResponse,
        undefined,
        "event"
    );

export const accessFetch = (
    ssoId: number,
    app: string,
    config?: AxiosRequestConfig,
    onResponse?: Function
) =>
    request(
        types.ACCESS_FETCH_REQUEST,
        types.ACCESS_FETCH_FAILED,
        types.ACCESS_FETCH_SUCCESS,
        "eventAccessFetch",
        {
            config: { ...config, params: { _app: app, ...config?.params } },
            url: { id: ssoId },
        },
        onResponse,
        undefined,
        "event"
    );

export const accessUpdate = (
    ssoId: number,
    app: string,
    data: any,
    config?: AxiosRequestConfig,
    onResponse?: Function
) =>
    request(
        types.ACCESS_UPDATE_REQUEST,
        types.ACCESS_UPDATE_FAILED,
        types.ACCESS_UPDATE_SUCCESS,
        "eventAccessUpdate",
        {
            config: { ...config, params: { _app: app, ...config?.params } },
            data,
            url: { id: ssoId },
        },
        onResponse,
        undefined,
        "event"
    );

export const accessDelete = (
    ssoId: number,
    app: string,
    locationId: number,
    config?: AxiosRequestConfig,
    onResponse?: Function
) =>
    request(
        types.ACCESS_DESTROY_REQUEST,
        types.ACCESS_DESTROY_FAILED,
        types.ACCESS_DESTROY_SUCCESS,
        "eventAccessDelete",
        {
            config: { ...config, params: { _app: app, ...config?.params } },
            url: { id: ssoId, locationId },
        },
        onResponse,
        undefined,
        "event"
    );
